export default __webpack_public_path__ + "static/media/017-flasher.dc33576a.png";